import styled from 'styled-components';

import { Tooltip as TooltipElement } from '@speeki/global-ui-components';

export const Tooltip = styled(TooltipElement)`
    z-index: 9;
`;
